export const ROLE_TYPES = {
  APPSUMO: -1,
  BASIC: 0,
  PREMIUM: 1,
  PRO: 2,
  ELITE: 3,
  STANDARD: 4,
  ESSENTIALS: 5,
  GROWTH: 6,
  SCALE: 7,
  PLUS: 8,
  PRO_V2: 9,
  LAUNCH: 10,
}

// Audiences mirror the marketing site's Creator / Enterprise split.
export const AUDIENCES = {
  CREATOR: 'creator',
  ENTERPRISE: 'enterprise',
}

// Which tab /pricing opens on for a given current plan.
export const AUDIENCE_BY_GROUP = {
  [ROLE_TYPES.BASIC]: AUDIENCES.CREATOR,
  [ROLE_TYPES.STANDARD]: AUDIENCES.CREATOR,
  [ROLE_TYPES.PREMIUM]: AUDIENCES.CREATOR,
  [ROLE_TYPES.PRO]: AUDIENCES.CREATOR,
  [ROLE_TYPES.PLUS]: AUDIENCES.CREATOR,
  [ROLE_TYPES.PRO_V2]: AUDIENCES.CREATOR,
  [ROLE_TYPES.APPSUMO]: AUDIENCES.CREATOR,
  [ROLE_TYPES.ELITE]: AUDIENCES.ENTERPRISE,
  [ROLE_TYPES.ESSENTIALS]: AUDIENCES.ENTERPRISE,
  [ROLE_TYPES.LAUNCH]: AUDIENCES.ENTERPRISE,
  [ROLE_TYPES.GROWTH]: AUDIENCES.ENTERPRISE,
  [ROLE_TYPES.SCALE]: AUDIENCES.ENTERPRISE,
}

export const roleTypes = [
  {
    id: 1,
    groupId: ROLE_TYPES.BASIC,
  },
  {
    id: 2,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 3,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 4,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 5,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 6,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 7,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 8,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 9,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 10,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 11,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 12,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 13,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 14,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 15,
    groupId: ROLE_TYPES.PRO,
  },
  {
    id: 16,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 17,
    groupId: ROLE_TYPES.PRO,
  },
  {
    id: 18,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 19,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 20,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 21,
    groupId: ROLE_TYPES.ELITE,
  },
  {
    id: 22,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 23,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 24,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 27,
    groupId: ROLE_TYPES.ESSENTIALS,
  },
  {
    id: 28,
    groupId: ROLE_TYPES.GROWTH,
  },
  {
    id: 29,
    groupId: ROLE_TYPES.STANDARD,
  },
  {
    id: 30,
    groupId: ROLE_TYPES.SCALE,
  },
  {
    id: 31,
    groupId: ROLE_TYPES.SCALE,
  },
  {
    id: 32,
    groupId: ROLE_TYPES.APPSUMO,
  },
  // 33/34/35 = CreatorPlus / CreatorPro / Launch in
  // mcg-backend-net src/Domain/Enums/RoleType.cs.
  {
    id: 33,
    groupId: ROLE_TYPES.PLUS,
  },
  {
    id: 34,
    groupId: ROLE_TYPES.PRO_V2,
  },
  {
    id: 35,
    groupId: ROLE_TYPES.LAUNCH,
  },
  {
    id: 36,
    groupId: ROLE_TYPES.APPSUMO,
  },
]
